// extracted by mini-css-extract-plugin
export default {"wrapper":"Ey-z","response":"Fy-z","error":"Gy-z","disabled":"Hy-z","buttons":"Iy-z","feedbackQuestionSection":"Jy-z","yesNoWrapper":"Ky-z"};